// STUDIO-MOBILE-CONTROL-BARS-UX-1 · 조작바 손잡이 (탭 = 토글 · 스와이프 = 방향별 열기/닫기 · 손잡이 영역만 제스처 인식).
import React, { useRef } from 'react';
import { ChevronLeft, ChevronRight, LayoutGrid } from 'lucide-react';

const SWIPE_PX = 18;

export const useSwipeToggle = ({ open, setOpen, axis = 'y', openDir = -1 }) => {
  const start = useRef(null);
  const onPointerDown = (e) => {
    e.stopPropagation();
    start.current = { x: e.clientX, y: e.clientY };
    try { e.currentTarget.setPointerCapture(e.pointerId); } catch {}
  };
  const onPointerUp = (e) => {
    e.stopPropagation();
    const s = start.current;
    start.current = null;
    if (!s) return;
    const d = axis === 'y' ? e.clientY - s.y : e.clientX - s.x;
    if (Math.abs(d) < SWIPE_PX) setOpen(!open);
    else setOpen(Math.sign(d) === openDir);
  };
  const onPointerCancel = () => { start.current = null; };
  return { onPointerDown, onPointerUp, onPointerCancel, style: { touchAction: 'none' } };
};

// 하단바 좌우 접기 버튼 (설정 오른쪽 · 오른쪽 스와이프 = 접기 · 왼쪽 = 펼치기 · 탭 = 토글).
export const BottomBarToggle = ({ open, setOpen }) => {
  const g = useSwipeToggle({ open, setOpen, axis: 'x', openDir: -1 });
  const Icon = open ? ChevronRight : ChevronLeft;
  return (
    <button type="button" {...g}
            className="lg:hidden shrink-0 w-10 h-11 rounded-full bg-white/85 text-gray-800 backdrop-blur-md border border-black/10 shadow-lg inline-flex items-center justify-center select-none"
            aria-label={open ? '하단 조작바 접기' : '하단 조작바 펼치기'} aria-expanded={open}
            data-testid={open ? 'live-console-bottom-collapse' : 'live-console-bottom-expand'} data-open={open ? '1' : '0'}>
      <Icon size={18} />
    </button>
  );
};

// 오른쪽 바 접힘 상태 — 가장자리 작은 탭 (탭 또는 왼쪽 스와이프로 펼침).
export const RailCollapsedTab = ({ onOpen }) => {
  const g = useSwipeToggle({ open: false, setOpen: (v) => { if (v) onOpen(); }, axis: 'x', openDir: -1 });
  return (
    <button type="button" {...g}
            className="lg:hidden absolute z-30 w-8 h-16 rounded-l-2xl bg-white/85 text-gray-800 backdrop-blur-md border border-r-0 border-black/10 shadow-lg inline-flex flex-col items-center justify-center gap-1 pointer-events-auto"
            style={{ ...g.style, top: 'calc(env(safe-area-inset-top) + 4rem)', right: 'env(safe-area-inset-right)' }}
            aria-label="오른쪽 조작바 펼치기" data-testid="live-console-rail-expand">
      <ChevronLeft size={16} />
      <LayoutGrid size={13} />
    </button>
  );
};

export default BottomBarToggle;
